var exports = {
  "k": "container__nrrwi2",
};

module.exports = exports;
